/**
 * 清理对象中值为 null 或 undefined 的键
 * @param obj 需要清理的对象
 * @returns 清理后的新对象
 */
export function cleanNullishParams<T extends Record<string, any>>(
  obj: T,
): Partial<T> {
  const cleaned: Partial<T> = {};
  
  for (const [key, value] of Object.entries(obj)) {
    if (value !== null && value !== undefined) {
      cleaned[key as keyof T] = value;
    }
  }
  
  return cleaned;
}